/**
 * offlineNoticeStore — Overlay/banner global «sin internet».
 *
 * QUÉ HACE: Pantalla blanca proactiva al perder conexión; banner compacto si el
 * usuario elige continuar en modo local.
 * QUÉ NO DEBE HACER: Lógica de caja ni impresión.
 */
import { create } from "zustand";

interface OfflineNoticeState {
  /** Dispositivo con acceso a internet (Wi‑Fi/datos). */
  online: boolean;
  /** Usuario pulsó «Continuar sin internet» en esta sesión. */
  dismissed: boolean;
  setOnline: (online: boolean) => void;
  dismissForSession: () => void;
  resetDismiss: () => void;
}

export const useOfflineNoticeStore = create<OfflineNoticeState>((set) => ({
  online: typeof navigator !== "undefined" ? navigator.onLine !== false : true,
  dismissed: false,
  setOnline: (online) =>
    set((s) => ({
      online,
      dismissed: online ? false : s.dismissed,
    })),
  dismissForSession: () => set({ dismissed: true }),
  resetDismiss: () => set({ dismissed: false }),
}));
